/**
 * Created by renjie.huang on 2017/11/13.
 */
import _ from '_';

var upperCase = /[A-Z]/,
    lowerCase = /[a-z]/,
    numbers = /[0-9]/,
    specialChars = /[^A-Za-z0-9]/g;
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function strength(password, minLength, maxLength) {
    if (password.match(/\s/)) {
        return -1;
    } else if(!password.trim() || password.length < minLength || password.length > maxLength) {
        return 0;
    }
    var hasUpperCase = password.match(upperCase) ? 1 : 0,
        hasLowerCase = password.match(lowerCase) ? 1 : 0,
        hasNumbers = password.match(numbers) ? 1 : 0,
        matchedSpecialChars = password.match(specialChars),
        strength = hasUpperCase + hasLowerCase + hasNumbers + (matchedSpecialChars ? 1 : 0);

    if(matchedSpecialChars && matchedSpecialChars.length >= 6) {
        if (strength >= 2 && strength < 4) {
            strength++;
        }
    }


    return strength;
}

var minLength = 6;
var maxLength = 20;

function getStrength(password){
    return strength(password, minLength, maxLength);
}


/**
 * 密码规则数组，分别是匹配大小写英文，数字，特殊字符和长度匹配
 * 长度必须在6-20位内
 * @type {RegExp[]}
 */
var regArr = [
    new RegExp(/[A-z]/),
    /[0-9]/,
    /[^A-Za-z0-9]/g,

]

var lengthReg = /.{10,20}/;

function getV2Strength(password,minLength){

    if(!password){
        return 0;
    }

    //密码包含空格，返回-2
    if(!/^[^ ]+$/.test(password)){
        return -2
    }

    //密码字符数量小于6个，返回-1
    if(password.trim().length < minLength){
        return -1;
    }
    //密码字符数量大于20，返回-1
    if(password.trim().length >32){
        return 1;
    }
    //验证三种规则中满足的数量，大于两种返回count否则返回1
    var _count = 0;
    for(var i=0;i<regArr.length;i++){
        if(password.match(regArr[i])){
            _count +=1;
        }
    }

    if(_count < 2){
        return 1;
    }

    if(password.match(lengthReg)){
        _count += 1;
    }

    return _count;
}


module.exports = getV2Strength;


// WEBPACK FOOTER //
// src/common/checkPassword.js